export default __webpack_public_path__ + "static/media/titulo_argentina.f83d615b.png";